import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./InvitationPopUp.css";
import Modal from "@mui/material/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { getCastingCallByCallerID,addInvitation } from "../../api/axios";
import Alert from "../common/Alert";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

const InvitationPopUp = ({ closeModal, producerId, isModalOpen, selectedActorsIds, resetSelection }) => { // Added selectedActorsIds and resetSelection
    const navigate = useNavigate();
    const [castingCalls, setCastingCalls] = useState([]);
    const [selectedCastingId, setSelectedCastingId] = useState("");
    const [roles, setRoles] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState(""); // NEW: Track selected role ID

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success"); // 'success', 'error', 'warning', 'info'
    const [alertMessage, setAlertMessage] = useState("");

    const triggerAlert = (message, severity) => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setOpenSnackbar(true);
    };

    const numberOfUsers = selectedActorsIds.length; // Use selectedActorsIds directly

    const fetchCastingCall = async (producerId) => {
        try {
            const res = await getCastingCallByCallerID(producerId);
            if (res.success) {
                setCastingCalls(res.casting);
                // console.log("Castings:", res.casting);
            }
        } catch (error) {
            // console.log("Error fetching casting call:", error);
        }
    };

    useEffect(() => {
        if (isModalOpen && producerId) {
            fetchCastingCall(producerId);
        }
    }, [isModalOpen, producerId]);

    const handleCastingChange = (e) => {
        const castingId = e.target.value;
        setSelectedCastingId(castingId);
        setSelectedRoleId(""); // Clear selected role when casting changes

        const selectedCasting = castingCalls.find(casting => casting.id === parseInt(castingId));
        setRoles(selectedCasting ? selectedCasting.roles : []);
    };

    const handleRoleChange = (e) => {
        setSelectedRoleId(e.target.value);
    };

    const sendInvitation = async () => {
        // console.log("Selected Casting ID:", selectedCastingId);
        // console.log("Selected Role ID:", selectedRoleId);

        if(!selectedRoleId){
            triggerAlert("Please select a role.","error");
            return;
        }
        if(!selectedCastingId){
            triggerAlert("Please select a casting call.","error");
            return;
        }
        
        try {
            const res = await addInvitation({
                roleId: selectedRoleId,
                castingId: selectedCastingId,
                userIds: selectedActorsIds // Use selectedActorsIds here
            });
    
            if (res?.success) {
                triggerAlert(res?.message || "Invitations sent successfully!","success");
                resetSelection(); // Call resetSelection here
            } else {
                triggerAlert(res?.message || "Invitation failed.","error")
            }
        } catch (error) {
            console.error("Error sending Invitations", error.response?.data || error.message);
            triggerAlert("An error occurred while sending the invitation.","error")
        }
    };

    return (
    <div>
            <Modal open={isModalOpen} onClose={closeModal}>
            <div className="invitation-modal-wrapper">
                <div className="actor-modal-close" onClick={closeModal}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>

                <div className="avatar-container">
                    <AvatarGroup total={numberOfUsers}
                        sx={{ justifyContent: "flex-end", display: "flex" }}
                    >
                        <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                        <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                        <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                        <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
                        <Avatar alt="Trevor Henderson" src="/static/images/avatar/5.jpg" />
                    </AvatarGroup>
                    <div>
                        <h6>INVITE</h6>
                        <h6>{numberOfUsers} <b>Talents</b></h6>
                    </div>
                </div>
                
                <div className="separate-line"></div>

                {/* First Dropdown: Casting Calls */}
                <div className="dropdown-section">
                    <select
                        value={selectedCastingId}
                        onChange={handleCastingChange}
                        className="invitation-dropdown"
                    >
                        <option value="">Select a Casting Call</option>
                        {castingCalls.map((casting) => (
                            <option key={casting.id} value={casting.id}>
                                {casting.title}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Second Dropdown: Roles */}
                {roles.length >= 0 && (
                    <div className="dropdown-section">
                        <select
                            value={selectedRoleId}
                            onChange={handleRoleChange}
                            className="invitation-dropdown"
                        >
                            <option value="">Select a Role</option>
                            {roles.map((role) => (
                                <option key={role.id} value={role.id}>
                                    {role.title} ({role.description})
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                <button className="invitation-button" onClick={sendInvitation}>
                    INVITE TO APPLY
                </button>
            </div>
            
        </Modal>
        <Alert
            openSnackbar={openSnackbar}
            alertSeverity={alertSeverity}
            setOpenSnackbar={setOpenSnackbar}
            alertMessage={alertMessage}
        />
       </div>
    );
};

export default InvitationPopUp;
